/**
 * Persistenz des Auth-Tokens (Bearer-Modus).
 * Bei Cookie-Session-Betrieb bleibt der Store leer und wird ignoriert.
 */
const STORAGE_KEY = 'hoseaus.token';

let memoryToken: string | null = null;

export function getToken(): string | null {
  if (memoryToken !== null) return memoryToken;
  try {
    memoryToken = localStorage.getItem(STORAGE_KEY);
  } catch {
    memoryToken = null;
  }
  return memoryToken;
}

export function setToken(token: string | null): void {
  memoryToken = token;
  try {
    if (token) localStorage.setItem(STORAGE_KEY, token);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage nicht verfügbar (z. B. Private Mode) — nur Memory nutzen
  }
}
